import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RotateCcw } from "lucide-react";
import { PermissionMatrix } from "@/components/PermissionMatrix";

const clone = (o) => JSON.parse(JSON.stringify(o || {}));

const samePerms = (a, b, modules) =>
  modules.every((m) => m.actions.every((x) => !!a?.[m.key]?.[x] === !!b?.[m.key]?.[x]));

export const UserAccessField = ({ role, permissions, onChange, roles, modules, isAdmin, testId }) => {
  const options = roles.filter((r) => r.id !== "admin" || isAdmin);
  const sector = roles.find((r) => r.id === role);
  const defaults = sector?.permissions || {};
  const current = permissions || defaults;
  const customized = !!sector && !sector.locked && !samePerms(current, defaults, modules);

  return (
    <div className="space-y-3" data-testid={`${testId}-field`}>
      <div className="space-y-2">
        <Label>Setor</Label>
        <Select value={role} onValueChange={(v) => onChange({ role: v, permissions: clone(roles.find((r) => r.id === v)?.permissions) })}>
          <SelectTrigger data-testid={testId}><SelectValue placeholder="Selecione o setor" /></SelectTrigger>
          <SelectContent>
            {options.map((r) => <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {sector && (
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-2">
            <Label className="flex items-center gap-2">
              Permissoes deste usuario
              {customized && <Badge className="bg-amber-100 text-amber-800 text-[10px]" data-testid={`${testId}-customized-badge`}>Personalizado</Badge>}
            </Label>
            {customized && (
              <Button type="button" variant="outline" size="sm" onClick={() => onChange({ role, permissions: clone(defaults) })} data-testid={`${testId}-restore-btn`}>
                <RotateCcw className="h-3.5 w-3.5 mr-1" /> Restaurar padrao do setor
              </Button>
            )}
          </div>
          <p className="text-xs text-muted-foreground">
            {sector.locked ? "Administrador tem acesso total e nao pode ser restringido." : "Vem preenchido com o padrao do setor. Marque ou desmarque para ajustar so este usuario. Em Ordens, \"Editar\" inclui concluir etapas."}
          </p>
          <PermissionMatrix modules={modules} value={current} readOnly={!!sector.locked}
            onChange={(p) => onChange({ role, permissions: p })} />
        </div>
      )}
    </div>
  );
};
